import Vue from 'vue'
import VuePdfPreview from 'pdf-viewer-vue/dist/vue2-pdf-viewer'
Vue.component('VuePdfPreview', VuePdfPreview)
